// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .cg-dropdown .anticon {
  color: #a2a3a8;
}
/*# sourceMappingURL=GroupLevelSelect.css.map */`, "",{"version":3,"sources":["webpack://./GroupLevelSelect.less","webpack://./src/components/Header/GroupLevelSelect.less"],"names":[],"mappings":"AAAA;EAGI,cAAA;ACDJ;AACA,+CAA+C","sourcesContent":[".presize-root { \n .cg-dropdown {\n  .anticon {\n    color: #a2a3a8;\n  }\n}\n \n}",".presize-root .cg-dropdown .anticon {\n  color: #a2a3a8;\n}\n/*# sourceMappingURL=GroupLevelSelect.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
